import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import InvoiceDocument from "@/components/proposal/InvoiceDocument";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public customer invoice — the token in the URL is the credential.
export default function PublicInvoice() {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/invoices/${token}`)
      .then((r) => setDoc(r.data))
      .catch(() => setErr("This link is invalid or the invoice has been removed."));
  }, [token]);

  if (err) {
    return (
      <div className="min-h-screen bg-[#F2F1EF] flex items-center justify-center p-6" data-testid="public-invoice-error">
        <div className="bg-white border-l-4 border-[#FF5F15] px-8 py-7 max-w-md shadow-lg">
          <div className="text-[11px] font-black uppercase tracking-[0.2em] text-[#FF5F15]">Invoice unavailable</div>
          <p className="mt-2 text-sm text-zinc-600">{err}</p>
        </div>
      </div>
    );
  }
  if (!doc) {
    return (
      <div className="min-h-screen bg-[#F2F1EF] flex items-center justify-center" data-testid="public-invoice-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#FF5F15]" />
      </div>
    );
  }

  return (
    <InvoiceDocument
      doc={doc}
      onDownload={() => window.open(`${API}/public/invoices/${token}/pdf`, "_blank", "noopener")}
    />
  );
}
